import { useState } from 'react';
import { api } from '@/services/api.config';

/**
 * Refund one of an account's transactions on the partner's behalf. The refund route authenticates as
 * the account, so the caller passes that account's bearer — the same token the account page's other
 * tabs use — rather than the partner session's.
 */
export default function useRefundAccountTransaction() {
  const [refunding, setRefunding] = useState(false);

  async function refundAccountTransaction(transactionId: string, bearer: string) {
    try {
      setRefunding(true);

      const res = await api.postTransactionRefund({ TransactionID: transactionId }, bearer);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setRefunding(false);
    }
  }

  return { refunding, refundAccountTransaction };
}
